import { DragDropModal } from "../../../DragDropModal";
export const list = (data = {}) => {
    const isDisabled = !(data === null || data === void 0 ? void 0 : data.memberName) || !(data === null || data === void 0 ? void 0 : data.serviceDate);
    return [
        {
            id: "providerAddress",
            label: "Providers Name,  Address,  and Phone Number",
            disabled: isDisabled,
            checked: ["providerAddress", "providerName", "providerPhone"].every((field) => data === null || data === void 0 ? void 0 : data[field]),
        },
        {
            id: "providerNPIName",
            label: "Provider NPI Number",
            disabled: isDisabled,
            checked: ["providerNpiNum"].every((field) => data === null || data === void 0 ? void 0 : data[field]),
        },
        {
            id: "providerTAXIDName",
            label: "Provider TAX ID Number",
            disabled: isDisabled,
            checked: ["providerTaxId"].every((field) => data === null || data === void 0 ? void 0 : data[field]),
        },
        {
            id: "CPTCodes",
            label: "CPT Codes / Diagnosis Codes",
            disabled: isDisabled,
            checked: ["cptDiagnosisCode"].every((field) => data === null || data === void 0 ? void 0 : data[field]),
        },
        {
            id: "AmountCharged",
            label: "Amount Charged & Paid",
            disabled: isDisabled,
            checked: ["chargedAmount", "paidAmount"].every((field) => data === null || data === void 0 ? void 0 : data[field]),
        },
        {
            id: "providerSuperbill",
            label: 'A Provider Issued UB04, 1500 form, also known as a "Super Bill"',
            helperText: "(Please note- itemized statements, or patient portal screenshots will not be accepted)",
            disabled: isDisabled,
            checked: ["providerSuperbill"].every((field) => data === null || data === void 0 ? void 0 : data[field]),
        },
        {
            id: "paymentProof",
            label: "Proof of Payment for Services",
            helperText: "(We will only accept a receipt or copy of voided check)",
            disabled: isDisabled,
            checked: ["paymentProof"].every((field) => data === null || data === void 0 ? void 0 : data[field]),
        },
    ];
};
export const defaultState = (data) => {
    return list(data).reduce((acc, { id }) => (Object.assign(Object.assign({}, acc), { [id]: false })), {});
};
const fieldProps = {
    type: "text",
    minLength: 1,
    maxLength: 300,
};
export const modalFields = {
    providerAddress: {
        title: "Providers Name, Address, and Phone Number",
        fields: [
            Object.assign(Object.assign({}, fieldProps), { className: "provider-name", name: "providerName", value: "", label: "Provider Name", required: true, isValid: false }),
            Object.assign(Object.assign({}, fieldProps), { className: "provider-address", name: "providerAddress", value: "", label: "Provider Address", type: "text", maxlength: 300, multiline: true, rows: 7, required: true, isValid: false }),
            Object.assign(Object.assign({}, fieldProps), { className: "provider-phone-number", name: "providerPhone", type: "telephone", value: "", isValid: false, label: "Provider Phone Number", required: true }),
        ],
    },
    providerNPIName: {
        title: "Provider NPI Number",
        fields: [
            Object.assign(Object.assign({}, fieldProps), { className: "Provider-npi-number", name: "providerNpiNum", value: "", label: "Provider NPI Number", required: true }),
        ],
    },
    providerTAXIDName: {
        title: "Provider TAX ID Number",
        fields: [
            Object.assign(Object.assign({}, fieldProps), { className: "provider-TAXID-name", name: "providerTaxId", value: "", label: "Provider TAX ID Number", required: true }),
        ],
    },
    CPTCodes: {
        title: "CPT Codes / Diagnosis Codes",
        fields: [
            Object.assign(Object.assign({}, fieldProps), { className: "provider-cpt-codes", name: "cptDiagnosisCode", value: "", label: "CPT Codes / Diagnosis Codes", required: true }),
        ],
    },
    AmountCharged: {
        title: "Amount Charged & Paid",
        fields: [
            Object.assign(Object.assign({}, fieldProps), { label: "Amount Charged", name: "chargedAmount", value: "", className: "amount-charged", type: "tel", required: true }),
            Object.assign(Object.assign({}, fieldProps), { label: "Amount Paid", name: "paidAmount", value: "", className: "amount-paid", type: "tel", required: true }),
        ],
    },
    providerSuperbill: {
        title: 'A Provider Issued UB04, 1500 form, also known as a "Super Bill"',
        name: "providerSuperbill",
        fields: [],
        component: DragDropModal,
    },
    paymentProof: {
        title: "Proof of Payment for Services",
        name: "paymentProof",
        fields: [],
        component: DragDropModal,
    },
};
